/**
 * DI-3-C — "the metadata round trip is done" (decision N5: match is
 * automatic; there is no Match button any more):
 *
 *   POST /api/intake/v1/data-acquisitions/{id}/intake/metadata-complete
 *   (`metadataComplete`, intake/v1 1.9.0, DI-3-A)
 *
 * The body is empty — any property is a 400. The server weighs the tenant's
 * logs with both DI-D2 gates and answers `enqueued` (a log passes → the
 * geometry job, `matching`), `awaiting_logs` (none passes — the set waits and
 * wakes by itself on a matching log ingest), `unchanged` or `already_running`
 * — always a 200. Idempotent on the server; the runner still calls it ONCE
 * per set per session (story §4).
 */
import { intakeFetch } from "./intakeFetch.js";
import type { MetadataCompleteResult } from "./intakeTypes.js";

export type PostMetadataComplete = (
  dataAcquisitionId: string,
) => Promise<MetadataCompleteResult>;

export const postMetadataComplete: PostMetadataComplete = (dataAcquisitionId) =>
  intakeFetch<MetadataCompleteResult>(
    `/data-acquisitions/${encodeURIComponent(dataAcquisitionId)}/intake/metadata-complete`,
    { method: "POST" },
  );

/** The answer in the pilot's words (the handover row). */
export function metadataCompleteLine(outcome: string): string {
  switch (outcome) {
    case "enqueued":
      return "a flight log matches — geometry is running";
    case "awaiting_logs":
      return "no flight log yet — waiting for the RC to sync";
    case "already_running":
      return "geometry is already running";
    case "unchanged":
      return "nothing new to process";
    default:
      return outcome;
  }
}
